module.exports = __webpack_public_path__ + "static/images/inverterCountIcon.c3ee83c8.svg";